'use client';

import { T3kPlayerProvider } from 'neural-amp-modeler-wasm';
import { PropsWithChildren } from 'react';

export const AudioContextProvider = ({ children }: PropsWithChildren) => {
  return (
    // Engine assets are served from public/engine/ (synced from the installed
    // package by scripts/copy-nam-engine.mjs on pre{dev,build}) instead of the
    // package's default import.meta.url resolution, which Next's production
    // minifier can't process. Keep in sync with next.config.mjs (webpack
    // `parser.url` opt-out) and the copy script.
    <T3kPlayerProvider engineAssets={{ assetBaseUrl: '/engine/' }}>{children}</T3kPlayerProvider>
  );
};
